import { hasPermission, isSystemRole } from './roleUtils';

// Returns navigation items for the current user as plain data so both the
// sidebar (Navbar) and the command palette can render from a single source.
export function getNavItems(user) {
  const items = [];
  const push = (to, icon, label, exact = false) => items.push({ to, icon, label, exact });

  if (!user) return items;

  const isSystemUser = isSystemRole(user.role);

  if (isSystemUser) {
    switch (user.role) {
      case 'admin':
        push('/admin', 'home', 'Dashboard', true);
        push('/admin/recruiters', 'users', 'Recruiters');
        push('/admin/users', 'user', 'Users');
        push('/admin/students', 'graduation-cap', 'Students');
        push('/admin/reports', 'bar-chart', 'Reports');
        push('/admin/payments', 'dollar', 'Payments');
        push('/admin/notifications', 'bell', 'Notifications');
        push('/admin/audit', 'shield', 'Audit Logs');
        push('/admin/external-logs', 'database', 'External API Logs');
        push('/admin/letters', 'file-text', 'Official Letters');
        push('/admin/referral-code-emails', 'mail', 'Notify Recruiters');
        push('/admin/settings', 'settings', 'Settings');
        push('/profile', 'user', 'My Profile');
        break;
      case 'financial_officer':
        push('/financial', 'home', 'Dashboard', true);
        push('/financial/uploads', 'upload', 'Payment Uploads');
        push('/financial/recruiters', 'dollar', 'Recruiter Payments');
        push('/financial/reports', 'bar-chart', 'Reports');
        push('/profile', 'user', 'My Profile');
        break;
      case 'hr':
        push('/hr', 'home', 'Dashboard', true);
        push('/hr/applications', 'paperclip', 'Applications');
        push('/hr/recruiters', 'users', 'Recruiters');
        push('/hr/reports', 'bar-chart', 'Reports');
        push('/hr/letters', 'file-text', 'Official Letters');
        push('/hr/referral-code-emails', 'mail', 'Notify Recruiters');
        push('/profile', 'user', 'My Profile');
        break;
      case 'comms_marketing':
        push('/comms', 'home', 'Dashboard', true);
        push('/comms/recruiters', 'users', 'Recruiters');
        push('/comms/students', 'graduation-cap', 'Students');
        push('/comms/reports', 'bar-chart', 'Reports');
        push('/comms/notifications', 'bell', 'Notifications');
        push('/profile', 'user', 'My Profile');
        break;
      default:
        push('/recruiter', 'home', 'Dashboard', true);
        push('/recruiter/students', 'graduation-cap', 'My Students');
        push('/recruiter/payments', 'dollar', 'Payments');
        push('/recruiter/notifications', 'bell', 'Notifications');
        push('/recruiter/leaderboard', 'trophy', 'Leaderboard');
        push('/recruiter/letters', 'file-text', 'My Letters');
        push('/recruiter/profile', 'user', 'Profile');
    }
  } else {
    if (hasPermission(user.permissions, 'dashboard.view')) push('/admin', 'home', 'Dashboard', true);
    if (hasPermission(user.permissions, 'recruiters.view')) push('/admin/recruiters', 'users', 'Recruiters');
    if (hasPermission(user.permissions, 'users.view')) push('/admin/users', 'user', 'Users');
    if (hasPermission(user.permissions, 'students.view')) push('/admin/students', 'graduation-cap', 'Students');
    if (hasPermission(user.permissions, 'payments.view')) push('/admin/payments', 'dollar', 'Payments');
    if (hasPermission(user.permissions, 'payments.upload')) push('/financial/uploads', 'upload', 'Payment Uploads');
    if (hasPermission(user.permissions, 'reports.view')) push('/financial/reports', 'bar-chart', 'Reports');
    if (hasPermission(user.permissions, 'students.view_own')) {
      push('/recruiter/students', 'graduation-cap', 'My Students');
      push('/recruiter/payments', 'dollar', 'My Payments');
      push('/recruiter/leaderboard', 'trophy', 'Leaderboard');
    }
    if (hasPermission(user.permissions, 'dashboard.view')) push('/admin/notifications', 'bell', 'Notifications');
    if (hasPermission(user.permissions, 'system.audit')) {
      push('/admin/audit', 'shield', 'Audit Logs');
      push('/admin/external-logs', 'database', 'External API Logs');
      push('/admin/settings', 'settings', 'Settings');
    }
    if (hasPermission(user.permissions, 'profile.view')) push('/recruiter/profile', 'user', 'Profile');
    if (hasPermission(user.permissions, 'dashboard.view')) push('/profile', 'user', 'My Profile');
  }

  return items;
}
